import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "SubmitButtonWrapper",
  class: "ImporterRow"
}
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "DriverButton SubmitButton",
      type: "submit",
      value: "Submit",
      disabled: _ctx.isDisabled,
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.wrapUpProcess && _ctx.wrapUpProcess(...args)), ["prevent"]))
    }, null, 8 /* PROPS */, _hoisted_2)
  ]))
}